import moment from 'moment';

export const convertTime = (data: any) => moment(data).format('L');

export const timeRefactor = (time) => moment(time).format('YYYY-MM-DD HH:mm:ss');
